import styled, { css } from 'styled-components';
import { StyleProps } from './types';

const FADE_WIDTH = '20%';

const createGradient =
  (direction: string) =>
  ({ $backgroundColor }: StyleProps) =>
    `
  linear-gradient(${direction}, rgba(255, 255, 255, 0) 0%, ${$backgroundColor});
`;

const verticalStyles = css`
  &::before {
    background-image: ${createGradient('to top')};
    height: ${FADE_WIDTH};
    left: 0;
    right: 0;
    top: 0;
  }

  &::after {
    background-image: ${createGradient('to bottom')};
    bottom: 0;
    height: ${FADE_WIDTH};
    left: 0;
    right: 0;
  }
`;

const horizontalStyles = css`
  &::before {
    background-image: ${createGradient('to left')};
    bottom: 0;
    left: 0;
    top: 0;
    width: ${FADE_WIDTH};
  }

  &::after {
    background-image: ${createGradient('to right')};
    bottom: 0;
    right: 0;
    top: 0;
    width: ${FADE_WIDTH};
  }
`;

export const Root = styled.div<StyleProps>`
  height: 100%;
  position: relative;
  width: 100%;

  &::before,
  &::after {
    content: '';
    position: absolute;
    opacity: 0;
    pointer-events: none;
    transition: ${({ theme }) => theme.transitions.create('opacity', '300ms')};
    z-index: 1;
  }

  ${({ $start }) =>
    $start &&
    `
    &::before {
      opacity: 1;
    }
  `}
  ${({ $end }) =>
    $end &&
    `
    &::after {
      opacity: 1;
    }
  `}

  ${({ $axis }) => ($axis === 'x' ? horizontalStyles : verticalStyles)}
`;
